import React from 'react'
import View from './view'

const Privacy = ({ ...props }) => {
  //const navigate = useNavigate()
  //const handleClickOnLink = to => navigate(to)
  return <View {...props} />
}

export default Privacy
